'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getDeviceUtil = require('../../utils/get-device-util');

var _getDeviceUtil2 = _interopRequireDefault(_getDeviceUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withDevice = function withDevice(Wrapped) {
  var WithDevice = function (_React$Component) {
    _inherits(WithDevice, _React$Component);

    function WithDevice(props) {
      _classCallCheck(this, WithDevice);

      var _this = _possibleConstructorReturn(this, (WithDevice.__proto__ || Object.getPrototypeOf(WithDevice)).call(this, props));

      _this.timeout = null;
      _this.state = {
        device: {}
      };

      _this.onResize = _this.onResize.bind(_this);
      return _this;
    }

    _createClass(WithDevice, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        window.addEventListener('resize', this.onResize);

        var device = (0, _getDeviceUtil2.default)();
        this.setState({ device: device }, function () {
          return _this2.props.onInit(device);
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
      }
    }, {
      key: 'onResize',
      value: function onResize() {
        var _this3 = this;

        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(function () {
          var device = (0, _getDeviceUtil2.default)();
          _this3.setState({ device: device }, function () {
            return _this3.props.onResize(device);
          });
        }, 300);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            onInit = _props.onInit,
            onResize = _props.onResize,
            children = _props.children,
            props = _objectWithoutProperties(_props, ['onInit', 'onResize', 'children']);

        return _react2.default.createElement(
          Wrapped,
          _extends({ device: this.state.device }, props),
          children
        );
      }
    }]);

    return WithDevice;
  }(_react2.default.Component);

  WithDevice.propTypes = {
    children: _propTypes2.default.node,
    onInit: _propTypes2.default.func,
    onResize: _propTypes2.default.func
  };

  WithDevice.defaultProps = {
    onInit: function onInit() {
      return null;
    },
    onResize: function onResize() {
      return null;
    }
  };

  return WithDevice;
};

exports.default = withDevice;